import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuditLog } from "../../all_Interfaces";


interface InitialState {
    data: AuditLog[],
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: [] as AuditLog[],
    error: '',
    loading: false
}

const auditLogSlice = createSlice({
    name: "AddAuditLogs",
    initialState,
    reducers: {
        addAuditLogs(state, action: PayloadAction<AuditLog[]>) {
            state.data = action.payload;
        },
    },
});

export const { addAuditLogs } = auditLogSlice.actions;

export default auditLogSlice.reducer;